import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Hold = ({
  height = 18,
  width = 18,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 18 18" {...props}>
    <path
      d="M6.375 0.75H3.375C2.75368 0.75 2.25 1.25368 2.25 1.875V16.125C2.25 16.7463 2.75368 17.25 3.375 17.25H6.375C6.99632 17.25 7.5 16.7463 7.5 16.125V1.875C7.5 1.25368 6.99632 0.75 6.375 0.75Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.625 0.75H11.625C11.0037 0.75 10.5 1.25368 10.5 1.875V16.125C10.5 16.7463 11.0037 17.25 11.625 17.25H14.625C15.2463 17.25 15.75 16.7463 15.75 16.125V1.875C15.75 1.25368 15.2463 0.75 14.625 0.75Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
